<div class="wrapper-page wrapper-my-list">
  <tl-header></tl-header>
  <div class="wrapper-header-my-lists">
    <div class="header-my-lists">
      <span>
        {{'LISTS.my_lists' | translate}}
      </span>
      <button (click)="reorder()" [ngClass]="{'active': isReorder}" class="custom-btn custom-btn--gray">
        <img src="../../../../assets/icons/outline/icon-reorder.svg" alt="">
      </button>
    </div>
  </div>
  <div class="wrapper-content-my-lists">
    <div class="content-my-lists">
      <div class="filter-my-lists">
        <div class="wrapper-custom-search">
          <img class="icon-search" src="../../../assets/icons/outline/icon-search.svg" alt="">
          <input type="text" placeholder="{{'NEW_TEXT.search' | translate}}" [(ngModel)]="search" (input)="onSearchChange($event)">
          <div (click)="resetSearch()" class="wrapper-delete-search">
            <img src="../../../assets/icons/outline/icon-close.svg" alt="">
          </div>
        </div>
        <button [routerLink]="[PAGES_AND_PATHS.createList.pagePath]" class="custom-btn custom-btn--outline">
          <span>{{'NEW_TEXT.new_list' | translate}}</span>
          <img src="../../../../assets/icons/outline/icon-plus.svg" alt="">
        </button>
      </div>
      <div class="wrapper-custom-tabs-purple">
        <div class="custom-tab-purple" [ngClass]="{'active': activeListType === LystTypeFilter.allLysts}"
          (click)="changeListType(LystTypeFilter.allLysts)">
          <span>
            {{'LISTS.all' | translate}}
          </span>
        </div>
        <div class="custom-tab-purple active" [ngClass]="{'active': activeListType === LystTypeFilter.publicLysts}"
          (click)="changeListType(LystTypeFilter.publicLysts)">
          <img class="no-active" src="../../../../assets/icons/outline/icon-global.svg" alt="">
          <img class="active" src="../../../../assets/icons/fill/icon-globe.svg" alt="">
          <span class="visibility-text">
            {{'LISTS.public_lists' | translate}}
          </span>
        </div>
        <div class="custom-tab-purple" [ngClass]="{'active': activeListType === LystTypeFilter.privateLysts}"
          (click)="changeListType(LystTypeFilter.privateLysts)">
          <img class="no-active" src="../../../../assets/icons/outline/icon-lock.svg" alt="">
          <img class="active" src="../../../../assets/icons/fill/icon-lock.svg" alt="">
          <span class="visibility-text">
            {{'LISTS.private_list' | translate}}
          </span>
        </div>
      </div>
      <div class="wrapper-cards-list" #listsContainter (scroll)="onScroll($event)" cdkDropList [cdkDropListData]="lists"
        (cdkDropListDropped)="drop($event)">
        <div *ngFor="let list of lists" cdkDrag [cdkDragDisabled]="!isReorder"
          [routerLink]="[PAGES_AND_PATHS.singleList.pagePath, list.id, 'cards']" class="wrapper-card-list">
          <!-- Custom Drag Preview -->
          <div class="custom-preview" *cdkDragPreview>
            <img class="image-list" [src]="list.lyst_image_url" alt="">
            <div class="wrapper-card-list-info">
              <div class="wrapper-badges">
                <div class="badge gray">
                  <span>{{list.lyst_items_count}} {{list.lyst_items_count === 1 ? ('ITEMS.items' | translate) : ('ITEMS.items' | translate)}}</span>
                </div>
              </div>
              <span class="name-list">{{list | matchLocale}}</span>
              <span class="time-list">{{list.created_at | timeAgo}}</span>
            </div>
            <div class="wrapper-right-element">
              <img *ngIf="isReorder" src="../../../../assets/icons/outline/icon-menu.svg" alt="">
            </div>
          </div>
          <img class="image-list" [src]="list.lyst_image_url !== null ? list.lyst_image_url : 'assets/images/no-image.png'"  alt="">
          <div class="wrapper-card-list-info">
            <div class="wrapper-badges">
              <div class="badge gray">
                <span>{{list.lyst_items_count}} {{list.lyst_items_count === 1 ? ('ITEMS.items' | translate) : ('ITEMS.items' | translate)}}</span>
              </div>
            </div>
            <span class="name-list">{{list | matchLocale}}</span>
            <span class="time-list">{{list.created_at | timeAgo}}</span>
          </div>
          <div class="wrapper-right-element">
            <img *ngIf="isReorder" src="../../../../assets/icons/outline/icon-menu.svg" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
